import { render, staticRenderFns } from "./consignmentOutHis.vue?vue&type=template&id=350b3821&scoped=true"
import script from "./consignmentOutHis.vue?vue&type=script&lang=js"
export * from "./consignmentOutHis.vue?vue&type=script&lang=js"
import style0 from "./consignmentOutHis.vue?vue&type=style&index=0&id=350b3821&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350b3821",
  null
  
)

export default component.exports